import React, { Fragment, useEffect } from 'react';
import AboutAutzu from './AboutAutzu';
import Software from './Software';
import Hardware from './Hardware';
import Operations from './Operations';
import Growth from './Growth';
import JoinAutzu from './JoinAutzu';
import TorontoFooter from '../Layout/TorontoFooter';
import { Helmet } from 'react-helmet';
import SFFooter from '../Layout/SFFooter';
import NYCFooter from '../Layout/NYCFooter';
import OttawaFooter from '../Layout/OttawaFooter';

const Careers = props => {
  const pathname = props.match.path;
  return (
    <Fragment>
      <Helmet>
        <title>Autzu Careers</title>
        <meta
          name="description"
          content="Join the team at Autzu and be a part of the future of drivesharing. We partner with ridesharing platforms and OEMs across the globe to ensure the success of our drivesharing platform. We leverage our proprietary technology to launch and scale our operations in all major cities across the globe."
        />
      </Helmet>
      <div className="careersPage container">
        <AboutAutzu />
        <Software />
        <Hardware />
        <Operations />
        <Growth />
        <JoinAutzu />
        {pathname.includes('tor') ? (
          <TorontoFooter />
        ) : pathname.includes('sf') ? (
          <SFFooter />
        ) : pathname.includes('ott') ? (
          <OttawaFooter />
        ) : (
          <NYCFooter />
        )}
      </div>
    </Fragment>
  );
};

export default Careers;



// WEBPACK FOOTER //
// ./src/components/Careers/index.js